/**
 * 브라우저에 설정된 타임존에 맞게 Date 객체를 생성하고, 그 결과를 "YYYY-MM-DD" 형식의 문자열로 반환합니다.
 * @param date 변환할 Date 객체
 * @returns "YYYY-MM-DD"
 */
function getLocalYYYYMMDD(date) {
  return "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, "0"), "-").concat(String(date.getDate()).padStart(2, "0"));
}
/**
 * 브라우저에 설정된 타임존에 맞게 Date 객체를 생성하고, 그 결과를 "HH:MM AM/PM" 형식의 문자열로 반환합니다.
 *
 * - 시간은 12시간제로 표시됩니다.
 * @param date 변환할 Date 객체
 * @returns "HH:MM AM/PM" 형식의 문자열(output>> 12:00 AM)
 */
function getLocalHHMMperiod(date) {
  var hours = date.getHours();
  var minutes = String(date.getMinutes()).padStart(2, "0");
  var period = hours >= 12 ? "PM" : "AM";
  var hours12 = hours % 12 || 12; // Convert 0 to 12
  return "".concat(String(hours12).padStart(2, "0"), ":").concat(minutes, " ").concat(period);
}

export { getLocalHHMMperiod, getLocalYYYYMMDD };
